import React from 'react';
import { Segment, Button, Header, Image } from 'semantic-ui-react';

const Teapot = () => {
    return (
        <Segment placeholder>
            <Image src={"../../assets/error-418-im-a-teapot.png"} size='large' />

            <Header icon>
                client error response code indicates that the server refuses to brew coffee because it is, permanently, a teapot. A combined coffee/tea pot that is temporarily out of coffee should instead return 503. This error is a reference to Hyper Text Coffee Pot Control Protocol
            </Header>
            <Segment.Inline>
                <Button primary>
                    This is an Unused button
                </Button>
            </Segment.Inline>
        </Segment>
    );
};

export default Teapot;